import Config from '../../utils/Config';

class ProjectTeaser extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            uuid : uuid()
        };

        this.setHeight = this.setHeight.bind(this);
        this.show = this.show.bind(this);
    }

    componentDidMount() {
        var self = this;

        setTimeout(() => { self.setHeight() }, 100);
        $(window).resize(this.setHeight);
    }

    componentWillUnmount() {
        $(window).off('resize', this.setHeight);
    }

    setHeight() {
        var h = $('#'+this.state.uuid).width();
        var label_h = $('#'+this.state.uuid+' .project-teaser__meta').height();

        $('#'+this.state.uuid+' .project-teaser__meta').css({
            top : (h/2 - label_h/2)+'px'
        });
    }

    show() {
        this.props.onClick(this.props.id);
    }

    render() {
        return (
            <div
                className='project-teaser'
                id={this.state.uuid}
                onClick={this.show}>

                <img src={'/public/codi-studios/projects/'+this.props.name+'/teaser.jpg'} />

                <div
                    className='project-teaser__overlay'
                    onClick={this.show} />

                <div className='project-teaser__meta'>
                    <span dangerouslySetInnerHTML={{__html: this.props.title}} />
                </div>

            </div>
        );
    }
}

export default ProjectTeaser;



// WEBPACK FOOTER //
// ./ui_src/app/components/portfolio/ProjectTeaser.react.jsx